import clsx from 'clsx';
import { Button } from '@linktivity/link-ui';

import type { TrainOption } from '../../types';

import styles from './trainCard.module.css';

export interface TrainCardProps {
  train: TrainOption;
  selectLabel: string;
  unavailableLabel?: string;
  loading?: boolean;
  onSelect: (train: TrainOption) => void;
}

const TrainCard = ({
  train,
  selectLabel,
  unavailableLabel,
  loading = false,
  onSelect
}: TrainCardProps) => (
  <article className={clsx(styles.card, !train.actionable && styles.disabled)}>
    <div className={styles.trainRow}>
      <div className={styles.trainTime}>
        <span className={styles.time}>{train.departTime}</span>
        <span className={styles.station}>{train.departureStation}</span>
      </div>
      <div className={styles.middle}>
        <span className={styles.meta}>{train.duration}</span>
        <div className={styles.line} />
        <span className={styles.meta}>{train.trainName}</span>
      </div>
      <div className={styles.trainTime}>
        <span className={styles.time}>{train.arriveTime}</span>
        <span className={styles.station}>{train.arrivalStation}</span>
      </div>
    </div>

    <div className={styles.actionRow}>
      <span
        className={clsx(
          styles.availability,
          styles[train.availabilityTone ?? 'unknown']
        )}
      >
        {train.availabilitySymbol && (
          <span className={styles.symbol}>{train.availabilitySymbol}</span>
        )}
        {train.availabilityLabel}
      </span>
      <Button
        variant="filled"
        className={styles.button}
        loading={loading}
        disabled={!train.actionable}
        onClick={() => onSelect(train)}
      >
        {train.actionable ? selectLabel : (unavailableLabel ?? selectLabel)}
      </Button>
    </div>
  </article>
);

export default TrainCard;
